exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-image-place-holder{-ms-flex-align:center;align-items:center;background-color:#e0e0e0;display:-ms-flexbox;display:flex;height:100%;-ms-flex-pack:center;justify-content:center}.product-image-place-holder .place-holder-text{color:#fff;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/product-image/product-image.scss
// module id = 5277
// module chunks = 0